"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Wrap = _interopRequireDefault(require("./Wrappers/Wrap"));

var _Radio = _interopRequireDefault(require("../Components/Radio"));

var _decorator = _interopRequireDefault(require("../utils/decorator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _decorator.default)({
  type: 'text',
  component: _Radio.default
})(_Wrap.default);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-final-form-components/dist/Bs/Radio.js
// module id = 2001
// module chunks = 0